import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchBaseQueryWithTokenCheck } from '@shared/utils/api.utils';

import type { Tenant } from './tenants.types';

interface EditTenantMutationBody {
  active: boolean;
  name: string;
  domain: string;
  type: string;
}

interface EditTenantArgs {
  body: EditTenantMutationBody;
  tenantId: string;
}

interface CreateTenantMutationBody extends EditTenantMutationBody {
  adminEmail: string;
}

interface CreateTenantArgs {
  body: CreateTenantMutationBody;
  companyId: string;
}

interface CurrentTenantInfo {
  tenantId: string;
  companyName: string;
  tenantName: string;
}

export const tenantsApiSlice = createApi({
  reducerPath: 'tenantsApi',
  baseQuery: fetchBaseQueryWithTokenCheck,
  endpoints: (builder) => {
    return {
      getTenants: builder.query<Tenant[], string>({
        query: (companyId) => `/api/v1/backend/companies/${companyId}/tenants`,
      }),
      createNewTenant: builder.mutation<Tenant, CreateTenantArgs>({
        query: ({ body, companyId }) => ({
          url: `/api/v1/backend/tenants/${companyId}`,
          method: 'POST',
          body,
        }),
      }),
      editTenant: builder.mutation<Tenant, EditTenantArgs>({
        query: ({ body, tenantId }) => ({
          url: `/api/v1/backend/tenants/${tenantId}`,
          method: 'PUT',
          body,
        }),
      }),
      getCurrentTenantInfo: builder.query<CurrentTenantInfo, void>({
        query: () => '/api/v1/tenants/my_tenant',
      }),
    };
  },
});

export const { useGetCurrentTenantInfoQuery } = tenantsApiSlice;
